export default __webpack_public_path__ + "static/media/bird2.c774eacb.svg";